import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlaneDeparture,
  faBoxesStacked,
  faPersonMilitaryPointing,
  faMapLocationDot,
  faCartFlatbed,
  faHandshake,
} from "@fortawesome/free-solid-svg-icons";



export const Services = (props) => {
  return (
    <div id="services" className="text-center">
    
    </div>
  );
};
